module.exports = __webpack_public_path__ + "static/footer-8c2c2a0990a84e09bb25842cb15d172d.png";